import { render, staticRenderFns } from "./StatisticsTable.vue?vue&type=template&id=18040506&scoped=true&"
import script from "./StatisticsTable.vue?vue&type=script&lang=js&"
export * from "./StatisticsTable.vue?vue&type=script&lang=js&"
import style0 from "./StatisticsTable.vue?vue&type=style&index=0&id=18040506&prod&lang=scss&scoped=true&"
import style1 from "./StatisticsTable.vue?vue&type=style&index=1&id=18040506&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18040506",
  null
  
)

export default component.exports